import Stack from '../Stack';
import UpgradeToSpateProLink from './UpgradeToSpateProLink';
import styled from 'styled-components';

const MessageWrapper = styled(Stack)`
    font-family: ${({ theme }) => theme.style_primary};
    font-size: ${({ theme }) => theme.fontSize_base};
    text-align: center;
    padding: 2rem 1.5rem;
    margin-top: 3rem;
    text-wrap: balance;
`;

const MessageHeading = styled.h2`
    margin-top: 0;
    padding: 0;
    font-family: inherit;
    font-weight: 600;
    font-size: 1rem;
    color: ${({ theme }) => theme.gray_2};
    text-transform: capitalize;
`;

const MessageParagraph = styled.p`
    margin-top: 0;
    padding: 0;
    font-family: ${({ theme }) => theme.style_primary};
    font-weight: 400;
    font-size: 1rem;
    color: ${({ theme }) => theme.gray_3};
    line-height: 1.25em;
`;

function NoAccessMessageMarkets(props) {
    return (
        <MessageWrapper $space="2rem">
            <Stack $space="1.5rem">
                <MessageHeading>Looking for something?</MessageHeading>
                <MessageParagraph>
                    Book a meeting with your Spate Account Manager to gain
                    access to international markets.
                </MessageParagraph>
            </Stack>
            <Stack css="display: flex; justify-content: center;">
                <UpgradeToSpateProLink />
            </Stack>
        </MessageWrapper>
    );
}

export default NoAccessMessageMarkets;
